export default __webpack_public_path__ + "static/media/RingRingHands.036cd85e.png";